<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Frame 3">
    <g id="Group 1">
      <path
        id="path20"
        d="M21.5662 12.0331C21.5662 7.04425 17.5219 3 12.5331 3C7.54425 3 3.5 7.04425 3.5 12.0331C3.5 16.2694 6.41642 19.824 10.3509 20.8002V14.7934H8.48821V12.0331H10.3509V10.8436C10.3509 7.76907 11.7423 6.34401 14.7608 6.34401C15.333 6.34401 16.3205 6.4562 16.7245 6.56843V9.07073C16.5112 9.0483 16.141 9.03706 15.6809 9.03706C14.1997 9.03706 13.6274 9.59812 13.6274 11.0569V12.0331H16.5779L16.0711 14.7934H13.6274V21C18.1001 20.4598 21.5662 16.6514 21.5662 12.0331Z"
        fill="black"
      />
    </g>
  </g>
</svg>
